import DatePicker from 'react-datepicker'
import './Calendar.css'
import { memo } from 'react'

const CaledarComponent = (props) => {
	return (
		<DatePicker 
			startDate={props.startDate}
			endDate={props.endDate}
			selected={props.selected}
			onChange={props.onChange}
			value={props.value}
			minDate={props.minDate}
			dateFormat="dd.MM.yyyy"
		/>
	)
}

export const Calendar = memo(CaledarComponent)